const neurologicalDiseases = [
    "Alzheimer's Disease",
    "Parkinson's Disease",
    "Multiple Sclerosis (MS)",
    "Epilepsy",
    "Migraine",
    "Motor Neurone Disease",
    "Huntington's Disease",
    "Tourette Syndrome",
    "Narcolepsy",
    "Restless Legs Syndrome",
    "Epileptic Seizures",
    "Peripheral Neuropathy",
    "Guillain-Barré Syndrome",
    "Creutzfeldt-Jakob Disease",
    "Bell's Palsy",
    "Meniere's Disease",
    "Spinal Muscular Atrophy (SMA)",
    "Muscular Dystrophy",
    "Myasthenia Gravis",
    "Cluster Headache",
    "Trigeminal Neuralgia",
    "Charcot-Marie-Tooth Disease",
]

const neurological = neurologicalDiseases.reduce((accumulator, disease) => {
    accumulator.push({ category: 'Neurological', disease })
    return accumulator
}, [])

export default neurological